import { useState } from 'react';

export const Checkbox = (props) => {
    const { name, value } = props;
    const [inputs, setInputs] = useState(value);
    const values = value ? value.split(',') : [];
    const chooser = props.chooser ? props.chooser : [];
    return (
        <div key={name} className="row">
            <div className="label">{name}</div>
            {chooser.map((el, i) => {
                const inputId = `${name}-${i}`;
                const target = document.getElementById(inputId);
                const active = value && value.includes(el.id) ? 'active-check' : 'default';
                return (
                    <div className="list-checkbox" key={i}>
                        <input type="checkbox" name={name} id={inputId} defaultValue={inputs} onChange={(e) => {
                            if (values.includes(e.target.value)) {
                                values.splice(values.indexOf(el.id), 1);
                                e.target.checked = false;
                            } else {
                                values.push(String(el.id));
                                e.target.checked = true;
                            }
                            target.value = values.join(',');
                            setInputs(target.value)
                        }
                        } />
                        <label htmlFor={inputId} className={`label ${active}`}>{el.name} ({el.id})</label>
                    </div>
                )
            })}
            <input className="control" type="text" id={name} name={name} defaultValue={inputs} />
        </div>
    )
}